import styled from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

import { AssetsService } from "app/services/AssetsService";

export const StyledFindAppsMovedStateFlex = styled(Flex)`
    margin-left: 189px;
    position: relative;
    height: 100%;
    justify-content: center;
    align-items: center;
    background: url(${AssetsService.assetUrl("/images/light-background.png")});
    background-size: 100%;
    background-repeat: no-repeat;
`;

export const StyledFindAppsMovedImg = styled.img`
    width: calc(100% + 16px);
    max-width: unset;
    margin: 0 -8px;
`;
